
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import {Grid, Typography} from "@mui/material";
import Box from "@mui/material/Box";

import Genomics from "../../dashboard/components/genomics-dashboard/genomics/Genomics";
import MappedText from "../../study-page/create-study/analysis-page/components/clinical-info/mapText";
import {Paper} from "@mui/material";
import SaveDialog from "../../dashboard/components/genomics-dashboard/components/results/components/toolbar/save_dialog/SaveDialog";
import { setStudySettings } from "../../dashboard/reducers/study_actions";



function getFindingsType(analysis) {


    if(analysis){
        if (analysis.toLowerCase().includes("somatic")) {
            return "Somatic Genetic Findings";
        } else if (analysis.toLowerCase().includes("germline")) {
            return "Germline Genetic Findings";
        }
        else if (analysis.toLowerCase().includes("fusion")) {
            return "Gene Fusions";
        }

        else {
            return "Unknown"; // Default case if neither is found
        }
    }
    else{
        return analysis;
    }

}


function GeneticFindings(props) {

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setStudySettings({ instandGeneticFindingsTab: props.instandGeneticFindingsTab }));
        return () => {
            dispatch(setStudySettings({ instandGeneticFindingsTab: undefined }));
        };
    }, [dispatch, props.instandGeneticFindingsTab]);

    let text = getFindingsType(props.analysisType);


    const renderView = () => {
        return <Genomics instandGeneticFindingsTab={props.instandGeneticFindingsTab}/>


    }


    return <>
            <Grid container direction={"row"}>
                <Grid item xs={12}>
                    <Typography variant={"h5"} style={{  fontWeight: "700", marginTop: "20px"}}><MappedText text={text}/></Typography>
                    <Grid container spacing={1}  mb={4}>
                        <Grid item xs={12} lg={12}>
                            <Box>
                                {renderView()}
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
                    <Paper
                                elevation={3}
                                sx={{
                                    position: "fixed",
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    height: "50px",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                    zIndex: 1000
                                }}
                            >
                                <SaveDialog/>
                            </Paper>
    </>


}

export default GeneticFindings;
